<script lang="ts" setup>
import { computed, defineAsyncComponent } from 'vue'
import { useTheme } from 'vuetify'

import LoginLayout from '@kidzonet/login-layout'
import Logo from '@kidzonet/logo'
import { useEnvVar } from '@kidzonet/vue3-env-var'

const theme = useTheme()

const saas = useEnvVar('VITE_SAAS')

const showOrangeCameroonAfterLogo = computed(() => saas === 'orange-cameroon')

const OrangeCameroonAfterLogo = defineAsyncComponent(() => import('./OrangeCameroonAfterLogo.vue'))
</script>

<template>
    <LoginLayout role="main">
        <template #logo>
            <Logo
                :fill="theme.current.value.colors.defaultPrimary as string"
            />
        </template>
        <template #after-logo>
            <OrangeCameroonAfterLogo
                v-if="showOrangeCameroonAfterLogo"
            />
        </template>
    </LoginLayout>
</template>
